import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { createCustomComponentAndPatchInfo, wasCreatedByNewInfo } from '../../utils/gallery';
export const WixProGalleryWithCustomInfo = WixProGallery => props => {
  const shouldUseNewInfo = wasCreatedByNewInfo(props.options);
  const customComponents = createCustomComponentAndPatchInfo(shouldUseNewInfo, props, props.options);
  return /*#__PURE__*/React.createElement(WixProGallery, _extends({}, props, {
    customComponents: customComponents
  }));
};
//# sourceMappingURL=withCustomInfo.js.map